/* ===============================================
    Antoine Letranchant 16-10-2026
    This js file overrides APO options tooltips
================================================= */

(function () {
  function bindOne(pill) {
    const circle = pill.querySelector('.mw-stack--pill__circle');
    if (!circle || circle.dataset.tipBound === '1') return;
    circle.dataset.tipBound = '1';
    pill.addEventListener('mouseenter', () =>
      circle.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true })));
    pill.addEventListener('mouseleave', () =>
      circle.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true })));
  }

  function bindAll() {
    document.querySelectorAll('.mw-stack--pill').forEach(bindOne);
  }

  // Initial pass
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', bindAll)
    : bindAll();

  // Re-bind whenever MageWorx injects/updates options
  const mo = new MutationObserver(bindAll);
  mo.observe(document.body, { childList: true, subtree: true });
})();